import { render, staticRenderFns } from "./VQShort.vue?vue&type=template&id=44fa8d94&scoped=true"
import script from "./VQShort.vue?vue&type=script&lang=js"
export * from "./VQShort.vue?vue&type=script&lang=js"
import style0 from "./VQShort.vue?vue&type=style&index=0&id=44fa8d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fa8d94",
  null
  
)

export default component.exports